import Link from "next/link";
import { useRouter } from "next/router";
import { useState } from "react";
import { Product, ProductList } from "../../../../models/product-list";
import { API } from "../../../../services/api-services";
import { ROUTES } from "../../../../services/router-services";
import { _, _c } from "../../../../services/text-services";
import FetchData from "../../../shared/fetch-data/fetch-data";
import styles from "./list.module.scss";
interface ListProps {
  productList: ProductList;
  
}
function List({ productList }: ListProps) {
  const router = useRouter();
  const numberOfProductsAdded =
    Number(process.env.NEXT_PUBLIC_HOME_PRODUCT_LIST_LIMIT) || 30;
  const [url, setUrl] = useState<string>("");
  const [limit, setLimit] = useState<number>(numberOfProductsAdded);
  const [products, setProducts] = useState<Product[]>(productList.products);
  const [showLoadMoreBtn, setShowLoadMoreBtn] = useState<boolean>(
    productList.products.length === limit + 1
  );

  const loadMore = () => {
    const url = router?.query?.slug?.[1];
    if(!url) return;
    setUrl(
      API.request_product_list(
        +url,
        limit + numberOfProductsAdded + 1
      )
    );
    setLimit(prevValue => prevValue + numberOfProductsAdded);
  };

  return (
    <div className={_c(styles, "product")}>
      {url && (
        <FetchData
          method="GET"
          url={url}
          onSuccessful={data => {
            const productList = data as ProductList;
            setProducts(productList.products);
            setShowLoadMoreBtn(
              productList.products.length === limit + 1 ? true : false
            );
          }}
          unAuthorized
          hidePending
        />
      )}

      <div className={_c(styles, "d-flex flex-wrap justify-content-center")}>
        {products.slice(0, limit).map(product => (
          <Link prefetch={false} 
            href={ROUTES.product(product)}
            key={product.id}
          >
            <a className={styles.item}>
              <img
                src={product.avatar["hdpi"]}
                alt={product.name || "no-product-name"}
                className={styles.item_img}
              />
              <p className={_c(styles, "title mr-1 mt-1")}>{_(product.name)}</p>
            </a>
          </Link>
        ))}
      </div>
      {showLoadMoreBtn && (
        <p className={_c(styles, "more m-2")} onClick={() => loadMore()}>
          مشاهده بیشتر
        </p>
      )}
    </div>
  );
}

export default List;
